import React, { FC, ReactNode, useMemo } from "react";

import ThemeContext, { TThemeVariant } from "./ThemeContext";

export interface IThemeProviderProps {
  /**
   * Visual representation of all inner components
   * Automatically sets 'variant' prop for all children
   *
   */
  theme: TThemeVariant;
  children?: ReactNode;
}

const ThemeProvider: FC<IThemeProviderProps> = ({
  theme = "light",
  children,
}) => {
  const themeContext = useMemo(() => ({ variant: theme }), [theme]);
  return (
    <ThemeContext.Provider value={themeContext}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
